module.exports = __webpack_public_path__ + "favicon-cd.png";